import { h, Component, Prop, EventEmitter, Event } from '@stencil/core';
import { UrlParamsForApiTablaDef } from '../../types/TablaDefTypes';

@Component({
  tag: 'tabladef-header',
  styleUrl: 'tabladef-header.css',
  shadow: true,
  assetsDirs: ['../assets'],
})
export class TabladefHeader {
  @Prop({ attribute: 'data-tabla' }) dataTabla: Partial<UrlParamsForApiTablaDef> = {};

  @Prop({ attribute: 'btn-state' }) btnState = {
    loadingData: false,
    changes: 0,
  };

  @Event({ eventName: 'save-btn-clicked' }) saveBtnClicked!: EventEmitter<void>;
  @Event({ eventName: 'cancel-btn-clicked' })
  cancelBtnClicked!: EventEmitter<void>;
  @Event({ eventName: 'exit-btn-clicked' }) exitBtnClicked!: EventEmitter<void>;

  render() {
    return (
      <div class='container'>
        <div class='logo-title'>
          <hgroup>
            <h1>Tablas Empleados</h1>
            <h4>
              Tabla empleado--&gt; {this.dataTabla.Cab_Id ?? 'N/A'} Empleado--&gt; {this.dataTabla.Emp_Codigo ?? 'N/A'}
            </h4>
          </hgroup>
        </div>
        <div class='toolbar'>
          <generic-button
            deshabilitado={this.btnState.changes === 0}
            buttonLabel={this.btnState.loadingData ? '...' : `Grabar (${this.btnState.changes})`}
            btnOnClick={() => this.saveBtnClicked.emit()}
            estado={this.btnState.loadingData ? 'cargando' : 'normal'}
          ></generic-button>
          <generic-button
            deshabilitado={this.btnState.changes === 0}
            buttonLabel={'Cancelar'}
            btnOnClick={() => this.cancelBtnClicked.emit()}
            estado={'normal'}
          ></generic-button>
        </div>
      </div>
    );
  }
}
